import Debouncer from "../util/Debouncer";
import { isFunction } from "../util/util";
import { IconButton } from "./TooltipControls";
import * as React from "react";
import { FormGroup } from "react-bootstrap";
import FormFeedback from "./FormFeedback";
/**
 * this is a wrapper for the text input-component that is styled like the
 * bootstrap FormControl component.
 * This wrapper uses a "cache" in the state to reduce the number of (costy)
 * rerenders caused by changing the redux store every keypress.
 * As a side effect, this fixes a problem where the cursor always jumps to
 * the end of the line when using controlled input.
 */
class FormInput extends React.PureComponent {
    mDebouncer;
    mLastCommitted;
    constructor(props) {
        super(props);
        this.state = {
            cachedValue: props.value,
        };
        this.mDebouncer = new Debouncer((newValue) => {
            const { onChange, value } = this.props;
            this.mLastCommitted = newValue;
            onChange(newValue, props.id);
            return null;
        }, this.props.debounceTimer || 1000);
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value &&
            this.mLastCommitted !== newProps.value) {
            this.mLastCommitted = newProps.value;
            this.setState({ cachedValue: newProps.value });
        }
    }
    render() {
        const { className, clearable, emptyIcon, groupClass, id, label, min, max, maxLength, placeholder, readOnly, style, type, validate, } = this.props;
        const { cachedValue } = this.state;
        const classes = ["form-input-container"];
        if (className !== undefined) {
            classes.push(className);
        }
        let icon = null;
        if (cachedValue) {
            if (clearable) {
                this.renderClear();
            }
        }
        else if (emptyIcon !== undefined) {
            icon = this.renderIcon(emptyIcon);
        }
        if (icon !== null) {
            classes.push("form-input-hasicon");
        }
        const content = (React.createElement("div", { className: classes.join(" "), style: style },
            React.createElement("input", { className: "form-control", type: type ?? "text", title: label, value: cachedValue, id: id, onChange: this.onChange, readOnly: readOnly, placeholder: placeholder, onBlur: this.onBlur, onFocus: this.onFocus, min: min, max: max, maxLength: maxLength }),
            icon));
        if (validate) {
            const validationState = this.validateRes(cachedValue);
            return (React.createElement(FormGroup, { className: groupClass, validationState: validationState },
                content,
                readOnly ? null : React.createElement(FormFeedback, null)));
        }
        else {
            return content;
        }
    }
    validateRes(value) {
        const { validate } = this.props;
        if (validate === undefined) {
            return null;
        }
        let validateRes = validate;
        if (isFunction(validate)) {
            validateRes = validate(value);
        }
        return validateRes;
    }
    renderIcon(iconName) {
        return (React.createElement(IconButton, { className: "form-input-clear btn-embed", icon: iconName, tooltip: undefined }));
    }
    renderClear() {
        return (React.createElement(IconButton, { className: "form-input-clear btn-embed", icon: "input-cancel", tooltip: undefined, onClick: this.clear }));
    }
    clear = () => {
        this.setState({ cachedValue: "" });
        this.mDebouncer.schedule(undefined, "");
    };
    onBlur = (evt) => {
        const { onFocus } = this.props;
        evt.preventDefault();
        if (onFocus) {
            onFocus(false);
        }
    };
    onFocus = (evt) => {
        const { onFocus } = this.props;
        evt.preventDefault();
        if (onFocus) {
            onFocus(true);
        }
    };
    onChange = (evt) => {
        const { type, min, max } = this.props;
        evt.preventDefault();
        let newValue = evt.currentTarget.value;
        if (type === "number" && newValue.length > 0) {
            let numValue = parseFloat(newValue);
            if (Number.isNaN(numValue)) {
                // ignore input if it's not valid
                evt.currentTarget.value = this.state.cachedValue.toString();
                return;
            }
            if (min !== undefined) {
                numValue = Math.max(numValue, min);
            }
            if (max !== undefined) {
                numValue = Math.min(numValue, max);
            }
            newValue = numValue.toString();
        }
        this.setState({ cachedValue: newValue });
        this.mDebouncer.schedule(undefined, newValue);
    };
}
export default FormInput;
